import React from 'react';
import { token } from '@atlaskit/tokens';
import './DotsAnimation.css';

export const DotsAnimation = () => {
  // Встановлюємо CSS змінні з використанням Atlaskit tokens
  const style = {
    '--color-text': token('color.text', '#172B4D'),
    '--color-text-secondary': token('color.text', '#6554C0'),
    '--color-text-disabled': token('color.text.disabled', '#DFE1E6'),
  };

  return (
    <div className="dotsContainer" style={style}>
      <div className="dot" />
    </div>
  );
};

export default DotsAnimation;
